import LazyWidgetController from "./lazy_widget_controller"

// Stimulus controller wrapping flatpickr for date / datetime text inputs.
//
// Lifecycle (lazy import + Turbo-cache-safe teardown) is handled by
// LazyWidgetController; this subclass only supplies load()/build().
//
// The enableTime flag is driven by a Stimulus value, matching the two original
// configs:
//   - enableTime true  (was .datetimepicker):
//       { enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, locale: { firstDayOfWeek: 1 } }
//   - enableTime false (was .datepicker):
//       { enableTime: false, dateFormat: 'Y-m-d', locale: { firstDayOfWeek: 1 } }
//
// Usage in views (rendered by AppFormBuilder app_date_picker / app_datetime_picker):
//   <input type="text" data-controller="flatpickr">                         (date)
//   <input type="text" data-controller="flatpickr" data-flatpickr-enable-time-value="true"> (datetime)
//
export default class extends LazyWidgetController {
  static values = { enableTime: Boolean }

  async load() {
    return (await import("flatpickr")).default
  }

  build(flatpickr) {
    const options = this.enableTimeValue
      ? {
          enableTime: true,
          dateFormat: 'Y-m-d H:i',
          time_24hr: true,
          locale: { firstDayOfWeek: 1 }
        }
      : {
          enableTime: false,
          dateFormat: 'Y-m-d',
          locale: { firstDayOfWeek: 1 }
        }

    return flatpickr(this.element, options)
  }

  // destroy() inherited from LazyWidgetController: flatpickr instance has .destroy().
}
